import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'keycloak-groups',
});

export const createGroupRouteRef = createRouteRef({
  id: 'keycloak-groups:create',
});

export const getGroupRouteRef = createSubRouteRef({
  id: 'keycloak-groups:get',
  parent: rootRouteRef,
  path: '/:groupId',
});
